import React from "react";

const CancelButton = ({onCancel}) => (
    <a className={"small"} onClick={onCancel}>or Cancel</a>
);

export default CancelButton;
